<template>
  <div class="config-page">
    <van-nav-bar left-arrow class="crystal-nav" @click-left="gotohome">
      <template #left>
        <van-icon name="arrow-left" size="20px" color="#475569" />
      </template>
      <template #title>
        <span class="nav-title">参数设置</span>
      </template>
    </van-nav-bar>

    <div class="content-area">
      <van-tabs v-model="activeTab" color="#2dd4bf" title-active-color="#0d9488" class="crystal-tabs">
        <van-tab title="补水设置">
          <div class="tab-content">
            <div class="config-block">
              <div class="config-item">
                <span class="config-label">补水开关</span>
                <van-switch v-model="config_re[0]" size="22" />
              </div>
              <div class="config-divider"></div>
              <div class="config-item">
                <span class="config-label">补水间隔（分钟）</span>
                <div class="config-stepper">
                  <van-stepper v-model="config_re[1]" min="1" max="99" step="1" />
                </div>
              </div>
              <div class="config-divider"></div>
              <div class="config-item">
                <span class="config-label">补水超时（分钟）</span>
                <div class="config-stepper">
                  <van-stepper v-model="config_re[2]" min="0" max="30" step="1" />
                </div>
              </div>
            </div>
            <div class="config-save-wrap">
              <button class="save-btn" :disabled="loading" @click="saveConfig">
                <span v-if="loading" class="save-btn-loading"></span>
                <span>{{ loading ? '保存中...' : '保存补水设置' }}</span>
              </button>
            </div>
          </div>
        </van-tab>

        <van-tab title="换水设置">
          <div class="tab-content">
            <div class="config-block">
              <div class="config-item">
                <span class="config-label">换水模式</span>
                <div class="config-select">
                  <van-radio-group v-model="config_wc[0]" direction="horizontal">
                    <van-radio name="0" class="crystal-radio">间隔模式</van-radio>
                    <van-radio name="1" class="crystal-radio">定时预约</van-radio>
                    <van-radio name="2" class="crystal-radio">手动模式</van-radio>
                  </van-radio-group>
                </div>
              </div>

              <template v-if="isWcInterval">
                <div class="config-divider"></div>
                <div class="config-item">
                  <span class="config-label">换水间隔（小时）</span>
                  <div class="config-stepper">
                    <van-stepper v-model="config_wc[1]" min="1" max="168" step="1" />
                  </div>
                </div>
                <div class="config-divider"></div>
                <div class="config-item">
                  <span class="config-label">排水时间（分钟）</span>
                  <div class="config-stepper">
                    <van-stepper v-model="config_wc[2]" min="1" max="99" step="1" />
                  </div>
                </div>
                <div class="config-divider"></div>
                <div class="config-item">
                  <span class="config-label">补海水超时（分钟）</span>
                  <div class="config-stepper">
                    <van-stepper v-model="config_wc[3]" min="0" max="30" step="1" />
                  </div>
                </div>
              </template>

              <template v-if="isWcScheduled">
                <div class="config-divider"></div>
                <div class="config-item">
                  <span class="config-label">排水时间（分钟）</span>
                  <div class="config-stepper">
                    <van-stepper v-model="config_wc[2]" min="1" max="99" step="1" />
                  </div>
                </div>
                <div class="config-divider"></div>
                <div class="config-item">
                  <span class="config-label">补海水超时（分钟）</span>
                  <div class="config-stepper">
                    <van-stepper v-model="config_wc[3]" min="0" max="30" step="1" />
                  </div>
                </div>
                <div class="config-divider"></div>
                <div class="config-item config-item--full">
                  <div class="config-weekdays">
                    <span v-for="(day, idx) in weekdays" :key="'wd' + idx" class="weekday-tag"
                      :class="{ 'weekday-active': (config_wc[4] >> idx) & 1 }" @click="toggleWeekday(idx)">
                      {{ day }}
                    </span>
                  </div>
                </div>
                <div class="config-divider"></div>
                <div class="config-item">
                  <span class="config-label">预约时间</span>
                  <div class="time-picker-trigger" @click="showTimePicker = true">
                    <span class="time-picker-text">{{ timeDisplay }}</span>
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                      <path d="M11 5L7 9L3 5" stroke="#94a3b8" stroke-width="1.5" stroke-linecap="round"
                        stroke-linejoin="round" />
                    </svg>
                  </div>
                </div>
              </template>

              <template v-if="isWcManual">
                <div class="config-divider"></div>
                <div class="config-item">
                  <span class="config-label">排水时间（分钟）</span>
                  <div class="config-stepper">
                    <van-stepper v-model="config_wc[2]" min="1" max="99" step="1" />
                  </div>
                </div>
                <div class="config-divider"></div>
                <div class="config-item">
                  <span class="config-label">补海水超时（分钟）</span>
                  <div class="config-stepper">
                    <van-stepper v-model="config_wc[3]" min="0" max="30" step="1" />
                  </div>
                </div>
              </template>
            </div>
            <div class="config-save-wrap">
              <button class="save-btn" :disabled="loading" @click="saveConfig">
                <span v-if="loading" class="save-btn-loading"></span>
                <span>{{ loading ? '保存中...' : '保存换水设置' }}</span>
              </button>
            </div>
          </div>
        </van-tab>

        <van-tab title="系统设置">
          <div class="tab-content">
            <div class="config-block">
              <div class="config-item">
                <span class="config-label">维护时长（分钟）</span>
                <div class="config-stepper">
                  <van-stepper v-model="config_sys[0]" min="1" max="99" step="1" />
                </div>
              </div>
              <div class="config-divider"></div>
              <div class="config-item">
                <span class="config-label">无水检测</span>
                <van-switch v-model="config_sys[1]" size="22" />
              </div>
              <div class="config-divider"></div>
              <div class="config-item">
                <span class="config-label">蜂鸣器报警</span>
                <van-switch v-model="config_sys[2]" size="22" />
              </div>
              <template v-if="hasTemp">
                <div class="config-divider"></div>
                <div class="config-item">
                  <span class="config-label">温度报警开关</span>
                  <van-switch v-model="config_sys[3]" size="22" />
                </div>
                <div class="config-divider"></div>
                <div class="config-item">
                  <span class="config-label">低温告警(℃)</span>
                  <div class="config-stepper">
                    <van-stepper v-model="config_sys[4]" min="0" max="99" step="1" />
                  </div>
                </div>
                <div class="config-divider"></div>
                <div class="config-item">
                  <span class="config-label">高温告警(℃)</span>
                  <div class="config-stepper">
                    <van-stepper v-model="config_sys[5]" min="0" max="99" step="1" />
                  </div>
                </div>
                <div class="config-divider"></div>
                <div class="config-item">
                  <span class="config-label">温度校准(℃)</span>
                  <div class="config-stepper">
                    <van-stepper v-model="config_sys[6]" min="-9.9" max="9.9" step="0.1" :decimal-length="1" />
                  </div>
                </div>
              </template>
            </div>
            <div class="config-save-wrap">
              <button class="save-btn" :disabled="loading" @click="saveConfig">
                <span v-if="loading" class="save-btn-loading"></span>
                <span>{{ loading ? '保存中...' : '保存系统设置' }}</span>
              </button>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>

    <van-popup v-model="showTimePicker" position="bottom" round>
      <van-datetime-picker v-model="timePickerCurrent" type="time" :min-hour="0" :max-hour="23" :min-minute="0"
        :max-minute="59" @confirm="onTimeConfirm" @cancel="showTimePicker = false" />
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "KD2Config",
  data() {
    return {
      activeTab: 0,
      did: this.$route.query.did,
      weekdays: ["一", "二", "三", "四", "五", "六", "日"],
      hasTemp: false,
      config_re: [1, 60, 2],
      config_wc: [0, 24, 10, 0, 127, 8, 0],
      config_sys: [30, 0, 1, 0, 20, 30, 0],
      loading: false,
      showTimePicker: false,
      timePickerCurrent: "08:00",
    };
  },
  computed: {
    isWcInterval() {
      return String(this.config_wc[0]) === "0";
    },
    isWcScheduled() {
      return String(this.config_wc[0]) === "1";
    },
    isWcManual() {
      return String(this.config_wc[0]) === "2";
    },
    timeDisplay() {
      var h = String(Number(this.config_wc[5]) || 0).padStart(2, "0");
      var m = String(Number(this.config_wc[6]) || 0).padStart(2, "0");
      return h + ":" + m;
    },
  },
  watch: {
    config_wc: {
      handler(val) {
        if (val && val.length >= 7) {
          var h = String(Number(val[5]) || 0).padStart(2, "0");
          var m = String(Number(val[6]) || 0).padStart(2, "0");
          this.timePickerCurrent = h + ":" + m;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    GetConfig() {
      const qs = require("qs");
      this.$axios
        .post("/api/dev/one", qs.stringify({ did: this.did }))
        .then((response) => {
          if (response.data.error_code === 0) {
            this.hasTemp = response.data.value && response.data.value.tpc != null;
            var cfg = response.data.config;
            if (cfg) {
              if (cfg.re) {
                var re = cfg.re.slice();
                re[0] = Boolean(re[0]);
                this.config_re = re;
              }
              if (cfg.wc) {
                var wc = cfg.wc.slice();
                wc[0] = String(wc[0]);
                this.config_wc = wc;
              }
              if (cfg.sys) {
                var arr = cfg.sys.slice();
                if (arr.length > 7) {
                  arr = arr.slice(1);
                }
                if (arr.length >= 7) {
                  arr[1] = Boolean(arr[1]);
                  arr[2] = Boolean(arr[2]);
                  arr[3] = Boolean(arr[3]);
                  arr[6] = arr[6] / 10.0;
                }
                this.config_sys = arr;
              }
            }
          }
        });
    },
    saveConfig() {
      this.loading = true;
      const qs = require("qs");
      var configData = {};
      if (this.activeTab === 0) {
        configData = {
          replenish_enable: this.config_re[0] ? 1 : 0,
          replenish_Interval: this.config_re[1],
          replenish_timeout: this.config_re[2],
        };
      } else if (this.activeTab === 1) {
        configData = {
          wc_mode: Number(this.config_wc[0]),
          wc_interval: this.config_wc[1],
          drain_time: this.config_wc[2],
          wc_replenish_timeout: this.config_wc[3],
          wc_cycle_week: this.config_wc[4],
          wc_fixed_hour: this.config_wc[5],
          wc_fixed_minute: this.config_wc[6],
        };
      } else if (this.activeTab === 2) {
        configData = {
          maintain_time: this.config_sys[0],
          no_water: this.config_sys[1] ? 1 : 0,
          alarm_beep: this.config_sys[2] ? 1 : 0,
          alarm_t: this.config_sys[3] ? 1 : 0,
          alarm_tl: this.config_sys[4],
          alarm_th: this.config_sys[5],
          alarm_jz: Math.round(this.config_sys[6] * 10),
        };
      }
      this.$axios
        .post("/api/dev/easy_mqtt_config", qs.stringify({
          did: this.did,
          d_type: "KD-2",
          config: JSON.stringify(configData),
        }))
        .then((response) => {
          this.loading = false;
          if (response.data.error_code === 0) {
            this.$toast.success("设置已保存");
          } else {
            this.$toast.fail("保存失败");
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$toast.fail("保存失败");
        });
    },
    onTimeConfirm() {
      var parts = String(this.timePickerCurrent).split(":");
      this.$set(this.config_wc, 5, parseInt(parts[0], 10) || 0);
      this.$set(this.config_wc, 6, parseInt(parts[1], 10) || 0);
      this.showTimePicker = false;
    },
    toggleWeekday(idx) {
      var val = this.config_wc[4] ^ (1 << idx);
      this.$set(this.config_wc, 4, val);
    },
    gotohome() {
      this.$router.go(-1);
    },
    setDefaultConfig(re, wc, sys) {
      if (re) this.config_re = re;
      if (wc) this.config_wc = wc;
      if (sys) this.config_sys = sys;
    },
  },
  mounted() {
    this.GetConfig();
  },
};
</script>

<style>
.crystal-nav {
  background: #ffffff !important;
  border-bottom: 1px solid #f1f5f9;
}

.nav-title {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
}

.crystal-tabs .van-tabs__wrap {
  background: #ffffff;
}

.crystal-tabs .van-tab {
  font-weight: 500;
}

.crystal-radio .van-radio__label {
  font-size: 13px;
}
</style>

<style scoped>
.config-page {
  min-height: 100vh;
  min-height: 100dvh;
  background: linear-gradient(145deg, #f0f9ff 0%, #fdf2f8 35%, #f0fdf4 100%);
}

.content-area {
  padding: 12px;
}

.tab-content {
  padding-top: 8px;
}

.config-block {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
  overflow: hidden;
}

.config-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  min-height: 22px;
  gap: 12px;
}

.config-item--full {
  justify-content: center;
  padding: 14px 12px;
}

.config-label {
  font-size: 14px;
  font-weight: 500;
  color: #475569;
  flex-shrink: 0;
}

.config-stepper {
  flex-shrink: 0;
}

.config-select {
  flex-shrink: 0;
}

.config-weekdays {
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 320px;
  gap: 4px;
}

.weekday-tag {
  width: 36px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  background: #f1f5f9;
  color: #94a3b8;
  cursor: pointer;
  transition: all 0.2s;
  user-select: none;
}

.weekday-tag:active {
  transform: scale(0.9);
}

.weekday-active {
  background: #2dd4bf;
  color: #fff;
  box-shadow: 0 2px 6px rgba(45, 212, 191, 0.25);
}

.config-divider {
  height: 1px;
  background: #f1f5f9;
  margin: 0 16px;
}

.config-save-wrap {
  padding: 16px 0 24px;
  display: flex;
  justify-content: center;
}

.save-btn {
  width: 100%;
  height: 44px;
  border: none;
  border-radius: 12px;
  background: linear-gradient(135deg, #2dd4bf, #14b8a6);
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: transform 0.15s, opacity 0.15s;
  box-shadow: 0 4px 12px rgba(45, 212, 191, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.save-btn:active {
  transform: scale(0.98);
  opacity: 0.9;
}

.save-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.save-btn-loading {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.time-picker-trigger {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  cursor: pointer;
  transition: border-color 0.2s;
  background: #f8fafc;
}

.time-picker-trigger:active {
  border-color: #2dd4bf;
}

.time-picker-text {
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
  min-width: 44px;
  text-align: center;
}
</style>